/* Based on @Paul Leech comment https://dev.to/bmsvieira/vanilla-js-fadein-out-2a6o */

import stopPreviousAnimation from './utils/stop-animation';

export function fadeIn({ $el, duration, display }) {
    return new Promise((resolve) => {
        stopPreviousAnimation($el);

        $el.style.opacity = $el.style.opacity || 0;
        $el.style.display = display || 'block';

        let last = +new Date();
        const tick = function() {
            $el.style.opacity = +$el.style.opacity + (new Date() - last) / duration;
            last = +new Date();

            if (+$el.style.opacity < 1) {
                if (window.requestAnimationFrame) {
                    $el.animationRafId = requestAnimationFrame(tick);
                } else {
                    $el.animationTimeoutId = setTimeout(tick, 16);
                }
            } else {
                $el.animationInProgress = false;
                $el.style.removeProperty('opacity');
                resolve();
            }
        };

        $el.animationInProgress = true;
        tick();
    });
}